import * as React from 'react';
import { Spinner } from '@estee/elc-spinner';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { SPINNER_CONTAINER } from '../../constants/DataTestIds';

const Container = styled.div`
    width: 200px;
    height: 200px;
    margin: 0 auto;
`;

export const SpinnerContainer = observer((props: { isLoading: boolean }) => (
    <Container data-test-id={SPINNER_CONTAINER}>
        <Spinner isLoading={props.isLoading} />
    </Container>
));
